import React, { useState } from 'react';
import './style.css';

const SectorsExpertise = () => {
  const [activeTab, setActiveTab] = useState('banking');

  const sectors = [
    {
      id: 'banking',
      name: 'Banking',
      icon: 'fa-landmark',
      color: '#7261eb',
      expertise: [
        {
          title: 'Core Banking Systems',
          description: 'Modernization of core banking infrastructures'
        },
        {
          title: 'Digital Payment Solutions',
          description: 'Integration of NFC, blockchain and open APIs'
        },
        {
          title: 'Enhanced Cybersecurity',
          description: 'Protection against cyber threats and electronic fraud'
        },
        {
          title: 'Data Analytics',
          description: 'Leveraging customer data to personalize financial services'
        },
        {
          title: 'Cloud Architectures',
          description: 'Secure migration to cloud environments compliant with regulations'
        }
      ]
    },
    {
      id: 'insurance',
      name: 'Insurance',
      icon: 'fa-shield-alt',
      color: '#7261eb',
      expertise: [
        {
          title: 'Policy Management Platforms',
          description: 'Automation of the insurance policy lifecycle'
        },
        {
          title: 'Specialized CRM Solutions',
          description: 'Intelligent customer relationship management and personalization'
        },
        {
          title: 'Artificial Intelligence',
          description: 'Predictive algorithms for risk assessment and pricing'
        },
        {
          title: 'Mobile Applications',
          description: 'Claims reporting and real-time tracking'
        },
        {
          title: 'IoT Integration',
          description: 'Data collection and analysis for connected insurance'
        }
      ]
    },
    {
      id: 'energy',
      name: 'Energy',
      icon: 'fa-bolt',
      color: '#7261eb',
      expertise: [
        {
          title: 'Advanced SCADA Systems',
          description: 'Monitoring and control of energy infrastructures'
        },
        {
          title: 'Smart Grids',
          description: 'Technologies for intelligent power grids'
        },
        {
          title: 'Asset Management Software',
          description: 'Optimization of equipment maintenance'
        },
        {
          title: 'IoT Platforms',
          description: 'Collection and analysis of smart meter data'
        },
        {
          title: 'Energy Efficiency Solutions',
          description: 'Monitoring and optimization of energy consumption'
        }
      ]
    },
    {
      id: 'healthcare',
      name: 'Healthcare',
      icon: 'fa-heartbeat',
      color: '#7261eb',
      expertise: [
        {
          title: 'Electronic Medical Records',
          description: 'Secure and interoperable solutions'
        },
        {
          title: 'Hospital Information Systems',
          description: 'Integrated management of clinical and administrative operations'
        },
        {
          title: 'Telemedicine Applications',
          description: 'Platforms for remote consultation and monitoring'
        },
        {
          title: 'Predictive Analytics',
          description: 'Algorithms to support diagnosis and clinical decision-making'
        },
        {
          title: 'Healthcare Data Security',
          description: 'GDPR compliance and certified health data hosting (HDS)'
        }
      ]
    },
    {
      id: 'public',
      name: 'Public Services',
      icon: 'fa-city',
      color: '#7261eb',
      expertise: [
        {
          title: 'e-Government Portals',
          description: 'Online public service platforms'
        },
        {
          title: 'Document Management Systems',
          description: 'Digitization and automation of administrative processes'
        },
        {
          title: 'Smart City Solutions',
          description: 'Intelligent management of urban infrastructures'
        },
        {
          title: 'Citizen Mobile Applications',
          description: 'Accessible and participatory public services'
        },
        {
          title: 'Secure IT Infrastructures',
          description: 'Protection of sensitive data and service continuity'
        }
      ]
    }
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const activeSector = sectors.find(sector => sector.id === activeTab);

  return (
    <div className="sectors-expertise-container">
      <div className="sectors-header">
        <h1>Our IT Expertise by Industry</h1>
        <p className="sectors-intro">
          With deep experience in information technologies, our company develops IT solutions tailored to the specific challenges of each industry.
        </p>
      </div>

      <div className="sectors-tabs">
        {sectors.map((sector) => (
          <div 
            key={sector.id}
            className={`sector-tab ${activeTab === sector.id ? 'active' : ''}`}
            onClick={() => handleTabClick(sector.id)}
            style={activeTab === sector.id ? { borderColor: sector.color } : {}}
          >
            <i className={`fas ${sector.icon}`}></i>
            <span>{sector.name}</span>
          </div>
        ))}
      </div>

      <div className="sector-content" style={{ borderColor: activeSector.color }}>
        <div className="sector-header" style={{ backgroundColor: activeSector.color }}>
          <h2>{activeSector.name}</h2>
        </div>
        <div className="expertise-list">
          {activeSector.expertise.map((item, index) => (
            <div className="expertise-item" key={index}>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="sectors-approach">
        <h2>Our Approach</h2>
        <div className="approach-items">
          <div className="approach-item">
            <i className="fas fa-lightbulb"></i>
            <p>Deep understanding of industry challenges</p>
          </div>
          <div className="approach-item">
            <i className="fas fa-users benefits-grid-color" ></i>
            <p>Domain-specialized teams</p>
          </div>
          <div className="approach-item">
            <i className="fas fa-search"></i>
            <p>Continuous technology monitoring</p>
          </div>
          <div className="approach-item">
            <i className="fas fa-tasks"></i>
            <p>Agile methodologies tailored to each project</p>
          </div>
          <div className="approach-item">
            <i className="fas fa-handshake"></i>
            <p>End-to-end support, from consulting to maintenance</p>
          </div>
        </div>
      </div>

      <div className="sectors-cta">
        <h3>Contact us to discover how our IT solutions can address the specific challenges of your industry.</h3>
        <button className="contact-btn" onClick={() => window.location.href = '/contact'}>Contact Us</button>
      </div>
    </div>
  );
};

export default SectorsExpertise;